// extracted by mini-css-extract-plugin
export default {"container":"viewer_container__LAtRT","toolbar":"viewer_toolbar__uBGKL","viewer":"viewer_viewer__9Oe38","iframe":"viewer_iframe__Pk7XF"};